import { useWindowWidth } from "@react-hook/window-size";

export const useGetIsDesktop = () => {
  const width = useWindowWidth();
  return width >= 1400;
};

export const useGetIsPhone = () => {
  const width = useWindowWidth();
  return width < 700;
};

export const useGetIsTablet = () => {
  const width = useWindowWidth();
  return width >= 700 && width < 1400;
};

export const setStyleProperty = (propery, color) => {
  document.documentElement.style.setProperty(propery, color);
};

export const emptyImage = `/images/empty.jpg`;

export const cnvToMultiline = (value) => {
  if (!value) return null;
  return value.split('\n').map(function( item, idx) {
      return (
          <span key={idx}>
            {item}
            <br/>
          </span>
      )
    })
}